window.addEventListener('DOMContentLoaded', function () {
    checkAndDisplayFreeSteer();
    checkCxUtm();
});

function checkAndDisplayFreeSteer() {
    if (window.scs_force_custom === true) {
    //localStorage.setItem('source', '');
    return;
  }
  if (window.location.href.indexOf('tw_source=fb') !== -1) {
        //localStorage.setItem('source', 'fb1');
    }
    if (window.location.href.toLowerCase().indexOf('utm_source=fb') !== -1) {
        //localStorage.setItem('source', 'fb1');
    }
    if (window.location.href.toLowerCase().indexOf('utm_source=facebook') !== -1) {
        //localStorage.setItem('source', 'fb1');
    }
    if (window.location.href.indexOf('tw_adid=steering-wheel-offer') !== -1) {
        //localStorage.setItem('source', 'fb1');
    }
    /*if (localStorage.getItem('source') === 'fb1' && window.scs_force_custom !== true) {
        
        document.querySelector('body').classList.add('source_fb');
        window.bonus_entry = true;

        if (document.querySelector('#bonus_entry')) {
            document.querySelector('#bonus_entry').checked = true;
            document.querySelector('#bonus_entry').addEventListener('change', function (e) {
                try {
                    gtag("event", "free_steeringwheel_change", {
                        state: e.target.checked,
                        page_location: window.location.href
                    });
                } catch (ex) {
                    console.error(ex);
                }
            });
        }
    }*/
}


function checkCxUtm() {
    const urlParams = new URLSearchParams(window.location.search);

    if (window.location.href.toLowerCase().indexOf('utm_medium=') !== -1) {
        sessionStorage.setItem('attribution', urlParams.get('utm_medium'));
        sessionStorage.setItem('utm_medium', urlParams.get('utm_medium'));
    }
    if (window.location.href.toLowerCase().indexOf('utm_source=') !== -1) {
        sessionStorage.setItem('attribution', urlParams.get('utm_source'));
        sessionStorage.setItem('utm_source', urlParams.get('utm_source'));
    }
    if (window.location.href.toLowerCase().indexOf('utm_campaign=') !== -1) {
        sessionStorage.setItem('attribution', urlParams.get('utm_campaign'));
        sessionStorage.setItem('utm_campaign', urlParams.get('utm_campaign'));
    }


    const ids = {
        'request_scs_attribution': 'attribution',
        'request_utm_campaign': 'utm_campaign',
        'request_utm_medium': 'utm_medium',
        'request_utm_source': 'utm_source'};
    for (const id of Object.keys(ids)) {
        console.log(id, ids[id], sessionStorage.getItem(ids[id]));
        if (document.getElementById(id) && sessionStorage.getItem(ids[id])) {
            document.getElementById(id).value = sessionStorage.getItem(ids[id]);
        }
    }
}
